export const doubleSlashRegExp = /(^|[^:])[/]{2,}/;
